<template>
  <el-dialog
    :title="this.$t('summaryDetail.title')"
    :visible.sync="dialogVisible"
    width="80%"
    class="fullScreenDialog"
    fullscreen
    @close="closeDialog"
  >
    <el-tabs class="batchTabs" type="border-card" v-model="tabActive">
      <!-- 采购合同明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.procurement')" name="procurement">
        <procurement ref="procurement" :slipStatus="rowItem.slipStatus" />
      </el-tab-pane>
      <!-- 业务入库单明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.putInStorage')" name="putInStorage">
        <put-in-storage ref="putInStorage" />
      </el-tab-pane>
      <!-- 销售明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.salesContract')" name="salesContract">
        <sales-contract ref="salesContract" :slipStatus="rowItem.slipStatus" />
      </el-tab-pane>
      <!-- 提单明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.ladingBill')" name="ladingBill">
        <lading-bill ref="ladingBill" />
      </el-tab-pane>
      <!-- 收款明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.collection')" name="collection">
        <collection ref="collection" />
      </el-tab-pane>
      <!-- 付款明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.payment')" name="payment">
        <payment ref="payment" />
      </el-tab-pane>
      <!-- 费用明细 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.cost')" name="cost">
        <cost ref="cost" />
      </el-tab-pane>
      <!-- 资金利息 -->
      <el-tab-pane :label="$t('summaryDetail.tabsName.fundsInterests')" name="fundsInterests">
        <funds-interests :settleNo="settleNo" ref="fundsInterests" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
  // import API from '@/api/capitalCenter/settle';
  import Procurement from './components/procurement'; // 采购合同明细
  import PutInStorage from './components/putInStorage'; // 业务入库单明细
  import Payment from './components/payment'; // 付款明细
  import SalesContract from './components/salesContract'; // 销售明细
  import LadingBill from './components/ladingBill'; // 提单明细
  import Collection from './components/collection'; // 收款明细
  import Cost from './components/cost'; // 费用明细
  import FundsInterests from './components/fundsInterests'; // 资金利息
  export default {
    name: 'summaryDetail',
    components: {
      Procurement,
      PutInStorage,
      Payment,
      SalesContract,
      LadingBill,
      Collection,
      Cost,
      FundsInterests,
    },
    data() {
      return {
        rowItem: {},
        settleNo: null,
        tabActive: 'procurement',
        dialogVisible: false,
        componentsList: [
          { componentKey: 'procurement', dataKey: 'purchaseContractDetailList' },
          { componentKey: 'putInStorage', dataKey: 'businessInboundDetailList' },
          { componentKey: 'salesContract', dataKey: 'salesContractDetailList' },
          { componentKey: 'ladingBill', dataKey: 'storageLadingPickingList' },
          { componentKey: 'payment', dataKey: 'fundPaymentList' },
          { componentKey: 'collection', dataKey: 'fundCollectionList' },
          { componentKey: 'cost', dataKey: 'expenseDetailList' },
          { componentKey: 'fundsInterests', dataKey: 'fundInterestList' },
        ],
      };
    },
    methods: {
      openDialog(rowItem) {
        this.tabActive = 'procurement';
        this.dialogVisible = true;
        this.rowItem = rowItem;
        this.$nextTick(() => this.importDetail(rowItem));
      },
      closeDialog() {
        // 弹窗关闭
        this.dialogVisible = false;
        this.settleNo = null;
        this.$emit('updateTableData', this.exportDetail());
      },
      importDetail(detail) {
        this.settleNo = detail.settleNo;
        this.componentsList.map((item) => {
          let tableData = [];
          let detailItem = detail[item.dataKey];
          if (detailItem) {
            detailItem.map((it) => {
              it.serializationJsonData = JSON.parse(it.serializationJsonData);
            });
            tableData = detailItem;
          }
          this.$refs[item.componentKey].tableData = tableData;
        });
      },
      exportDetail() {
        this.componentsList.map((item) => {
          let detailItem = this.rowItem[item.dataKey];
          if (detailItem && detailItem.length > 0) {
            detailItem.map((it) => {
              it.serializationJsonData = JSON.stringify(it.serializationJsonData);
            });
          } else {
            detailItem = null;
          }
        });
        return this.rowItem;
      },
    },
  };
</script>
